module.exports = __webpack_public_path__ + "img/1559686793.6de52dd9.jpg";